
import {toProductUrl} from '@util/URLUtils';
import Icon from '@components/common/Icon';
import ProductImage from '@components/common/ProductImage';
import LineItem, {Wrapper, Figure, Body, TitleLink, Sku, QtyField, PriceDisplay, PriceLine, Footer} from '../index';

const LineItemEditable = props =>
    <LineItem {...props}>
        {( {
               id,
               sku,
               product,
               quantity,
               maxQuantity,
               isLogged,
               displayPrice,
               priceRestricted,
               maxQuantityExceeded,
               ...rest
           } ) => (
            <Wrapper id={id}>
                <Figure>
                    <ProductImage {...product} width="90"/>
                </Figure>
                <Body>
                    <TitleLink href={toProductUrl( {path: product.url, sku} )}>{product.kitName}</TitleLink>
                    <Sku sku={product.sku}/>
                    <PriceLine>
                        <QtyField>
                            <input
                                tabIndex="1"
                                data-sx-product-qty
                                data-qty-select-toggle
                                data-allow-zero
                                type="number"
                                id={`skuQty_${id}`}
                                name={`skuQty_${id}`}
                                style="height: 1.5rem;padding-left:.25rem;padding-right:.25rem"
                                className="digits skuQtyField px-1 h-6 w-10 leading-normal rounded-sm"
                                value={quantity}
                                onKeyPress={rest.onInputKeyPress}
                                onBlur={rest.onInputBlur}
                                onChange={rest.onInputChange}
                                min="0"/>
                        </QtyField>
                        <PriceDisplay price={displayPrice}
                                      isLogged={isLogged}
                                      priceRestricted={priceRestricted}/>
                    </PriceLine>
                    {maxQuantityExceeded &&
                    <p className="font-bold text-warning my-2">
                        <Icon.ui name="report-problem-triangle" className="text-sm mr-1"/>
                        <span>This item is limited to {maxQuantity} per customer.</span>
                    </p>
                    }
                </Body>
                <Footer>
                    <span data-skuid={product.sku}
                          onClick={rest.onDeleteItem}
                          className="cursor-pointer pr-2 align-middle hover:color-fail">
                        <Icon.ui name="remove" className="text-base"/>
                    </span>
                </Footer>
            </Wrapper>
        )}
    </LineItem>;

export default LineItemEditable;
